import { StandardDialogFooter } from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, { useState } from "react";
import ActionDialogOrderList from "../order-list/action-dialog-order-list";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import ordersService from "../../../../services/orders.service";
import EmptyScanPopup from "./shared/empty";
import {
  Message,
  MessageSections,
} from "../../../../pages/components/message/message";
import orderGroupService from "../../../../services/order-group.service";
import { OrderGroupModel } from "../../../../pages/shared/models/order/orderGroupModel";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { getOrderGroups } from "../../../../redux/slices/order-group.slice";
import { ActionDialogContent } from "./shared/styled";
import { TrackNumberInput } from "./track-number-input";
import { standardDialogColumns } from "./shared/columns";

const AddToGroup = ({
  onCancel,
  orderGroup,
  preSelectedOrders,
  ordersUpdated,
}: AddToGroupDialogProps) => {
  const { orderStateId } = useAppSelector((state) => state.ordersReducer);

  const [orders, setOrders] = useState(preSelectedOrders || []);
  const {
    data: { currentPage },
  } = useAppSelector((state) => state.orderGroupReducer);

  const dispatch = useAppDispatch();

  function searchForOrder(trackingNumberToSearch: string) {
    if (
      !!trackingNumberToSearch.length &&
      !orders.some((order) =>
        order.products.some(
          (product) => product.trackingNumber === trackingNumberToSearch,
        ),
      )
    ) {
      const filter = { textQuery: trackingNumberToSearch };

      if (filter) {
        ordersService
          .getOrderByGivenFilterCriteria(filter)
          .then((order) => {
            if (order) {
              const newOrders = [...orders, order];
              updateOrders(newOrders);
            }
          })
          .catch((reason) => {
            console.error(reason);
          });
      }
    }
  }

  function addOrders() {
    if (orderGroup && orderGroup.ordersGroupId) {
      try {
        orderGroupService
          .editGroup(orderGroup.ordersGroupId, {
            orders: orders.filter(
              (order) =>
                !orderGroup.orders.some(
                  (groupOrder) => groupOrder.orderId === order.orderId,
                ),
            ),
          })
          .then((response) => {
            dispatch(
              getOrderGroups({
                orderStateId: orderStateId as number,
                page: currentPage,
                forceLoad: true,
              }),
            );

            onCancel();
          });
      } catch (e) {
        console.log(e);
      }
    }
  }

  function updateOrders(orders: OrderModel[]) {
    setOrders(orders);
    ordersUpdated(orders);
  }

  return (
    <>
      <ActionDialogContent>
        <TrackNumberInput onEnter={searchForOrder} />

        {orders.length ? (
          <ActionDialogOrderList
            orders={orders}
            columns={standardDialogColumns}
            updateOrders={updateOrders}
          />
        ) : (
          <EmptyScanPopup />
        )}
      </ActionDialogContent>

      <StandardDialogFooter
        saveLabel={
          <Message messageKey={"add"} sectionId={MessageSections.ORDERS} />
        }
        exportableOrders={orders}
        onSave={() => addOrders()}
        onCancel={() => onCancel()}
      />
    </>
  );
};

interface AddToGroupDialogProps {
  onCancel: () => void;
  preSelectedOrders?: OrderModel[];
  orderGroup?: OrderGroupModel;
  ordersUpdated: (orders: OrderModel[]) => void;
}

export default AddToGroup;
